import * as React from 'react';

function SvgHelpCenterListingYourProperties(props) {
  return (
    <svg height={64} width={64} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none">
        <path
          d="M60.23 60.22V26.662a3.725 3.725 0 00-3.726-3.726H45.308V11.75a3.725 3.725 0 00-3.725-3.725H15.486a3.72 3.72 0 00-3.736 3.725v48.47H9.888a1.86 1.86 0 00-1.863 1.862 1.86 1.86 0 001.863 1.863h52.204a1.86 1.86 0 001.863-1.863 1.86 1.86 0 00-1.863-1.862z"
          fill="#e2f4f2"
        />
        <path
          d="M33.583.025a3.725 3.725 0 013.725 3.725v11.186h11.196a3.725 3.725 0 013.726 3.726V52.22h1.862a1.86 1.86 0 011.863 1.862 1.86 1.86 0 01-1.863 1.863H1.888a1.86 1.86 0 01-1.863-1.863 1.86 1.86 0 011.863-1.862H3.75V3.75A3.72 3.72 0 017.486.025zM31.97 3.74H9.098c-.891 0-1.612.721-1.612 1.613V52.22h26.097V5.353c0-.892-.721-1.613-1.612-1.613zm14.91 14.922h-7.96c-.892 0-1.613.72-1.613 1.612V52.22h11.186V20.274c0-.891-.72-1.612-1.612-1.612zM27.986 33.573c1.031 0 1.873.831 1.863 1.863a1.86 1.86 0 01-1.863 1.862H13.074c-1.032 0-1.863-.83-1.863-1.862s.831-1.863 1.863-1.863zm0-11.186c1.031 0 1.873.831 1.863 1.863a1.86 1.86 0 01-1.863 1.862H13.074a1.86 1.86 0 01-1.863-1.862 1.86 1.86 0 011.863-1.863zm0-11.186c1.031 0 1.873.831 1.863 1.863a1.86 1.86 0 01-1.863 1.862H13.074a1.86 1.86 0 01-1.863-1.862 1.86 1.86 0 011.863-1.863z"
          fill="#38b2a6"
        />
      </g>
    </svg>
  );
}

export default SvgHelpCenterListingYourProperties;
